import React, { useEffect } from "react";
import AuthPage from "@/components/ui/AuthPage";
import { connect } from "react-redux";
import useStyles from './EmailChangeConfirmationCardStyles';
import { Container } from '@mui/material';
import { MdClear, MdDone } from "react-icons/md";
import { useParams } from "react-router-dom";
import { handleConfirmEmailChangeSubmit } from "./store/EmailChangeConfirmationCard";
import { hideProgressSpinner } from "@/lib/utils/ProgressSpinnerService";
import useHistory from "../../lib/hooks/useHistory";

interface Props {
    handleConfirmEmailChangeSubmit_d: (userId, tokenId) => void,
    confirmEmailState: any
}

const EmailChangeConfirmationCard: React.FC<Props> = (props) => {
    const { confirmEmailState: { success, successData, error, errorText }, handleConfirmEmailChangeSubmit_d } = props;

    const { userId }: any = useParams();
    const { tokenId }: any = useParams();

    const { classes } = useStyles()
    const history = useHistory();

    useEffect(() => {
        handleConfirmEmailChangeSubmit_d(userId, tokenId)
    }, [userId, tokenId]);

    useEffect(() => {
        hideProgressSpinner();
    }, [success, successData, error, errorText]);

    const navigateHome = () => {
        let path = '/login';
        history.push(path);
    }

    return (
        <>
            {success && (
                <AuthPage
                    title="Email address changed"
                    icon={<MdDone />}
                    iconTone="ok"
                    actions={<button type="button" className="pb-btn pb-btn-primary" onClick={navigateHome}>Go To Log In</button>}>
                    <p>Your email address has been successfully changed and you may now log in.</p>
                </AuthPage>
            )}
            {error && (
                <AuthPage
                    title="We could not change your email address"
                    icon={<MdClear />}
                    iconTone="bad"
                    actions={<button type="button" className="pb-btn pb-btn-outline" onClick={navigateHome}>Return to Home</button>}>
                    <p>{errorText}</p>
                </AuthPage>
            )}
        </>
    )

}

const mapStateToProps = (state: any) => ({
    confirmEmailState: state.confirmEmailChangeConfirmationCard
});

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleConfirmEmailChangeSubmit_d: (userId, tokenId) => dispatch(handleConfirmEmailChangeSubmit(userId, tokenId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailChangeConfirmationCard);